import {
  Box,
  Container,
  Grid,
  Heading,
  Image,
  Link,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import PublicationTable from './PublicationTable';

const greenPopupVillage = [
  {
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-10at55055PM-vxmFzQTqMcSQ.png',
    name: 'The Hindu Business Line',
  },
  {
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-10at55046PM-rSCFlHorLZDQ.png',
    name: 'The Hindu Business Line',
  },
  {
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-10at55038PM-JtapEtmLUn1x.png',
    name: 'Free Press Journal',
  },
  {
    logo: 'https://static.levocdn.com/WGLBUT82/Screenshot2025-01-10at55028PM-yCrH3MR3FBdb.png',
    name: 'The Hindu Business Line',
  },
];

const tableData = [
  {
    srNo: 1,
    publication: 'Press Trust of India',
    link: 'https://www.ptinews.com/story/business/india-s-potential-gdp-growth-is-in-range-of-6-5-7pc-says-cea/2033673',
    text: "India's potential GDP growth is in range of 6.5-7pc, says CEA",
    type: 'Wire',
  },
  {
    srNo: 2,
    publication: 'The Hindu Businessline',
    link: '',
    text: 'IFSCA to ease regulations, cut costs for funds operating in GIFT City, says Chairman Rajaraman',
    type: 'Print',
  },
  {
    srNo: 3,
    publication: 'The Hindu Businessline',
    link: '',
    text: 'CEA calls for deregulation to empower SMEs',
    type: 'Print',
  },
  {
    srNo: 4,
    publication: 'The Hindu Businessline',
    link: '',
    text: 'Startups industry must drive down hydrogen station costs',
    type: 'Print',
  },
  {
    srNo: 5,
    publication: 'The Hindu Businessline',
    link: 'https://www.thehindubusinessline.com/economy/cea-calls-for-deregulation-to-empower-indias-smes/article68939322.ece',
    text: 'CEA calls for deregulation to empower India’s SMEs',
    type: 'Online',
  },
  {
    srNo: 6,
    publication: 'The Hindu Businessline',
    link: 'https://www.thehindubusinessline.com/companies/start-ups-industry-must-drive-down-hydrogen-station-costs-nitin-gadkari/article68943068.ece/amp/',
    text: 'Start-ups, industry must drive down hydrogen station costs: Nitin Gadkari',
    type: 'Online',
  },
  {
    srNo: 7,
    publication: 'The Hindu Businessline',
    link: 'https://www.thehindubusinessline.com/economy/ifsca-to-ease-regulations-cut-costs-for-funds-operating-in-gift-city-says-chairman-rajaraman/article68938938.ece',
    text: 'IFSCA to ease regulations, cut costs for funds operating in GIFT City, says Chairman Rajaraman',
    type: 'Online',
  },
  {
    srNo: 8,
    publication: 'Business Standard',
    link: 'https://www.business-standard.com/economy/news/india-s-potential-gdp-growth-is-in-range-of-6-5-7-says-cea-nageswaran-124120200525_1.html',
    text: "India's potential GDP growth is in range of 6.5-7%, says CEA Nageswaran",
    type: 'Online',
  },
  {
    srNo: 9,
    publication: 'CNBC TV-18',
    link: 'https://www.cnbctv18.com/economy/indias-6-5-7-pc-gdp-growth-achievable-built-on-decade-of-reforms-chief-economic-advisor-v-anantha-nageswaran-19518103.htm',
    text: 'India’s 6.5–7% GDP growth achievable, built on decade of reforms: Chief Economic Advisor',
    type: 'Online',
  },
  {
    srNo: 10,
    publication: 'Outlook Planet',
    link: 'https://www.outlookbusiness.com/planet/sustainability/global-souths-lack-of-collaboration-in-climate-finance-key-to-failure-of-cop29-says-g20-sherpa-amitabh-kant',
    text: 'Disunited Global South to Blame for Poor Finance Deal at COP, Says Amitabh Kant',
    type: 'Online',
  },
  {
    srNo: 11,
    publication: 'ET Now',
    link: 'https://www.timesnownews.com/business-economy/economy/indias-gdp-growth-expected-to-reach-6-5-7-in-2024-25-says-chief-economic-advisor-article-115896288',
    text: "India's GDP Growth Expected To Reach 6.5-7% In 2024-25, Says Chief Economic Advisor",
    type: 'Online',
  },
  {
    srNo: 12,
    publication: 'News 18',
    link: 'https://www.timesnownews.com/business-economy/economy/indias-gdp-growth-expected-to-reach-6-5-7-in-2024-25-says-chief-economic-advisor-article-115896288',
    text: "India's Potential GDP Growth Is In Range Of 6.5-7%, Says CEA V Anantha Nageswaran",
    type: 'Online',
  },
  {
    srNo: 13,
    publication: 'Fortune India',
    link: 'https://www.fortuneindia.com/macro/economic-growth-is-key-to-energy-transition-says-cea-anantha-nageswaran/119373',
    text: 'Economic growth is key to energy transition, says CEA Anantha Nageswaran',
    type: 'Online',
  },
  {
    srNo: 14,
    publication: 'Deccan Chronicle',
    link: 'https://www.deccanchronicle.com/business/indias-potential-gdp-growth-pegged-at-657-percent-chief-economic-advisor-1843392',
    text: 'India’s Potential GDP Growth Pegged at 6.5–7 Percent: Chief Economic Advisor Business',
    type: 'Online',
  },
  {
    srNo: 15,
    publication: 'Deccan Herald',
    link: 'https://www.deccanherald.com/business/economy/indias-potential-gdp-growth-is-in-range-of-65-7-says-cea-anantha-nageswaran-3299926',
    text: "India's potential GDP growth is in range of 6.5-7%, says CEA Anantha Nageswaran",
    type: 'Online',
  },
  // Add more rows as needed...
];

export default function CoveragePrints() {
  return (
    <Container maxW="container.lg">
      <Box>
        <Heading
          my={20}
          fontWeight="700"
          fontSize={{ xs: '26px', md: '28px' }}
          lineHeight="130%"
          color="#197542"
          textAlign="left"
          mb="2rem"
          borderLeft="3px solid #197542"
          pl="10px"
        >
          Media Coverage Report
        </Heading>
        <PublicationTable data={tableData} />
      </Box>
      <Box>
        <Heading
          my={20}
          fontWeight="700"
          fontSize={{ xs: '26px', md: '28px' }}
          lineHeight="130%"
          color="#197542"
          textAlign="left"
          mb="2rem"
          borderLeft="3px solid #197542"
          pl="10px"
        >
          Coverage (Print)
        </Heading>
        <Grid
          templateColumns={{
            base: 'repeat(auto-fit, minmax(200px, 1fr))', // Adjust for small screens
            md: 'repeat(auto-fit, minmax(300px, 1fr))', // For medium screens
            lg: 'repeat(auto-fit, minmax(400px, 1fr))', // For larger screens
          }}
          gap={6}
        >
          {greenPopupVillage.map((startup, index) => (
            <Box
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
              p={3}
              textAlign="center"
              h="430px"
              boxShadow="4px 4px 4px 0px #98CAA7"
            >
              <VStack spacing={3}>
                <Image
                  src={startup.logo}
                  alt={`${startup.name} logo`}
                  boxSize="350px"
                  objectFit="contain"
                  mx="auto"
                />
                <Text fontSize="16px" fontWeight="semibold" color="#010E04">
                  {startup.name}
                </Text>
              </VStack>
            </Box>
          ))}
        </Grid>
      </Box>
    </Container>
  );
}
